export default __webpack_public_path__ + "static/media/TVS KING GS+ FULL_5.b8e1efff.webp";